<template lang="pug">
#message-register(v-cloak)
  // input message
  .box
    .box-header
      .clearfix(v-if="!isBusy")
        button.btn.float-right.setting-btn(@click="gotoSendMessageSettingEdit"
          :class="{ 'disable': _disableUseBasicSetting }" :disabled="_disableUseBasicSetting") 基本設定

        button.btn.float-right.template-btn(v-if="1 <= planType" @click="gotoSendMessageTemplateList"
          :class="{ 'disable': _disableUseTemplate }" :disabled="_disableUseTemplate") テンプレート

        button#disable-template-btn.btn.float-right.template-btn.disable(v-show="planType < 1") テンプレート
        b-popover(target="disable-template-btn" triggers="hover" placement="top")
          template(v-slot:title) テンプレート
          span タイトル、本文、見ましたボタン、既読確認メッセージ、返信ボタンをテンプレートとして保存し、メッセージ作成時に使用することができます。
          br
          span ※ ライトプラン以上で使用可能

        button.btn.float-right(@click="onExampleModal") 使用例
        .note
          span ご家族・施設関係者（職員など）に、メッセージ・写真等を送ることが出来ます。

    .box-body
      b-tabs(v-model="tabIndex" @activate-tab="activateTab" @changed="changedTab")
        //- sendmessage form tab
        b-tab.tab
          template(v-slot:title)
            .tab-name
              span.mr-1 新規送信
              .refresh-icon(@click.stop="refreshSendMessageForm" title="再読み込みします")
          SendMessageForm(ref="messageFormTab" @send="sendMessage" @saveDraftMessage="saveDraftMessage")

        //- draftmessage list tab
        b-tab.tab(v-if="1 <= planType && _enableUseSaveDraftMessage")
          template(v-slot:title)
            .tab-name
              span.mr-1 下書き一覧
              .refresh-icon(@click.stop="refreshDraftMessages" title="再読み込みします")
          DraftMessageList(ref="draftMessageListTab" @restoreDraftMessage="restoreDraftMessage")

        //- sendmessage history tab
        b-tab.tab
          template(v-slot:title)
            .tab-name
              span 履歴（家族）
              b-img.mr-1.incoming-icon(v-show="showSendMessageIncoming" src="@/assets/sidemenu-sendmessage-incoming.png")
              .refresh-icon(@click.stop="refreshFamilyMessageHistories" title="再読み込みします")
          SendMessageHistory(ref="familyMessageHistoriesTab" @openDetail="openDetailTab" @onDelete="onFamilyMessageDelete")

        //- otherusersendmessage history tab
        b-tab.tab(v-if="2 <= planType")
          template(v-slot:title)
            .tab-name
              span 履歴（施設関係者）
              b-img.mr-1.incoming-icon(v-show="showOtherUserGroupSendMessageIncoming" src="@/assets/sidemenu-sendmessage-incoming.png")
              .refresh-icon(@click.stop="refreshOtherUserMessageHistories" title="再読み込みします")
          SendMessageOtherUserHistory(ref="otherUserMessageHistoriesTab" @openDetail="openOtherUserDetailTab" @onDelete="onOtherUserMessageDelete")

        //- sendmessage detail tab
        b-tab(v-for="tab in tabs" :key="'tab-' + tab.no")
          template(v-slot:title)
            .message-detail-tab-title
              span.message-detail-tab-title-text.text-truncate.d-inline-block {{ tab.title }}
              button.close(type="button" @click="closeDetailTab") x
          SendMessageDetail(v-if="tab.type == 0" :message="tab.message")
          SendMessageOtherUserDetail(v-if="tab.type == 1" :message="tab.message")

  OkModal(v-model="showSendMessageSuccessModal" title="メッセージ送信を受け付けました。" @ok="onMessageClose")
  OkModal(v-model="showSaveDraftMessageSuccessModal" title="下書きを保存しました。" @ok="onDraftMessageClose")
  SendMessageExampleModal(ref="sendMessageExampleModal")

  CheckDeleteModal(v-model="showConfirmFamilyMessageDeleteModal" title="メッセージを削除します" @ok="deleteFamilyMessage(deleteTargetFamilyMessage)")
    template(#message)
      div 履歴からは削除されますが、受信者のメール・LINEトーク画面からは削除することができません。
      div.mb-2 よろしいですか？

  CheckDeleteModal(v-model="showConfirmOtherUserMessageDeleteModal" title="メッセージを削除します" @ok="deleteOtherUserMessage(deleteTargetOtherUserMessage)")
    template(#message)
      div 履歴からは削除されますが、受信者のメール・LINEトーク画面からは削除することができません。
      div.mb-2 よろしいですか？
  OkModal(v-model="showDeleteMessageSuccessModal" title="メッセージを削除しました")

  //- file upload error modal
  FileUploadErrorModal(v-model="showUploadErrorModal")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
  ProgressLoading(v-model="currentUploadCount" :max="uploadCount" :isBusy="progressLoading" :message="progressMessage")
</template>

<script lang="ts">
import { Component, Inject, Ref, Vue } from "vue-property-decorator";
import { userStore, screenInputTemporaryStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";
import { BTab } from "bootstrap-vue";
import Setting from "../../../../public/setting.json";

import { PcUrl } from "@/commons/constants/PcUrl";
import SendLineMessagesService, { SendLineMessagesPostModel } from "@/commons/services/SendLineMessages";
import SendMailMessagesService, { SendMailMessagesPostModel } from "@/commons/services/SendMailMessages";
import SendOtherUserMailMessagesService, { SendOtherUserMailMessagesPostModel } from "@/commons/services/SendOtherUserMailMessages";
import SendOtherUserMessagesService, { SendOtherUserMessagesagesPostModel } from "@/commons/services/SendOtherUserMessages";
import ExistS3FilesService, { ExistS3FilesPostModel } from "@/commons/services/ExistS3Files";
import S3LocationsService from "@/commons/services/S3Locations";
import { S3LocationRequest, S3LocationResponse, S3LocationType, S3LocationMessage } from "@/commons/models/S3Location";
import S3UploadsService from "@/commons/services/S3Uploads";
import MessageModel from "@/commons/models/Message";
import SendMessageRepliesService, { SendMessageRepliesUnreadModel } from "@/commons/services/SendMessageReplies";
import OtherUserGroupSendMessageRepliesService from "@/commons/services/OtherUserGroupSendMessageReplies";
import { PlanType } from "@/commons/services/Plans";
import DraftMessagesService, { DraftMessageFile, DraftMessagesGetModel, DraftMessagesPatchModel, DraftMessagesPostModel } from "@/commons/services/DraftMessages";
import MessagesService from "@/commons/services/Messages";
import OtherUserGroupMessagesService from "@/commons/services/OtherUserGroupMessages";
import S3UrlService from "@/commons/services/S3Url";

import FileUploadErrorModal from "@/pc/basics/FileUploadErrorModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import SendMessageForm from "@/pc/containers/sendMessages/SendMessageForm.vue";
import DraftMessageList from "@/pc/containers/sendMessages/DraftMessageList.vue";
import SendMessageHistory from "@/pc/containers/sendMessages/SendMessageHistory.vue";
import SendMessageOtherUserHistory from "@/pc/containers/sendMessages/SendMessageOtherUserHistory.vue";
import SendMessageDetail from "@/pc/containers/sendMessages/SendMessageDetailTab.vue";
import SendMessageOtherUserDetail from "@/pc/containers/sendMessages/SendMessageOtherUserDetailTab.vue";
import { SendMessageHistoryTableItem } from "@/pc/containers/sendMessages/SendMessageHistoryTable.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ProgressLoading from "@/pc/basics/ProgressLoading.vue";
import SendMessageExampleModal from "@/pc/components/modals/SendMessageExampleModal.vue";
import CheckDeleteModal from "@/pc/components/modals/CheckDeleteModal.vue";
import SystemError from "@/commons/models/SystemError";
import { ExtDraggableFile } from "@/pc/components/ExtDraggableFiles.vue";

/**
 * メッセージ送信画面コンポーネント
 */
@Component({
  components: {
    FileUploadErrorModal,
    PageLoading,
    ProgressLoading,
    OkModal,
    SendMessageForm,
    DraftMessageList,
    SendMessageHistory,
    SendMessageOtherUserHistory,
    SendMessageDetail,
    SendMessageOtherUserDetail,
    SendMessageExampleModal,
    CheckDeleteModal
  },
  name: "SendMessage",
  $_veeValidate: { validator: "new" }
})
export default class SendMessage extends Vue {
  /** メッセージ送信サービス */
  @Inject("SendLineMessagesService") sendLineMessagesService!: SendLineMessagesService;
  /** メッセージ送信サービス(施設関係者) */
  @Inject("SendOtherUserMessagesService") sendOtherUserMessagesService!: SendOtherUserMessagesService;
  /** メール送信サービス */
  @Inject("SendMailMessagesService") sendMailMessagesService!: SendMailMessagesService;
  /** メール送信サービス(施設関係者) */
  @Inject("SendOtherUserMailMessagesService") sendOtherUserMailMessagesService!: SendOtherUserMailMessagesService;
  /** S3格納先URLサービス */
  @Inject("S3LocationsService") s3LocationsService!: S3LocationsService;
  /** S3ファイルアップロードサービス */
  @Inject("S3UploadsService") s3UploadsService!: S3UploadsService;
  /** メッセージ送信の返信サービス */
  @Inject("SendMessageRepliesService") sendMessageRepliesService!: SendMessageRepliesService;
  /** メッセージ送信の返信サービス */
  @Inject("OtherUserGroupSendMessageRepliesService") otherUserGroupSendMessageRepliesService!: OtherUserGroupSendMessageRepliesService;
  /** S3ファイル存在確認サービス */
  @Inject("ExistS3FilesService") existS3FilesService!: ExistS3FilesService;
  /** メッセージ下書きサービス */
  @Inject("DraftMessagesService") draftMessagesService!: DraftMessagesService;
  /** メッセージサービス */
  @Inject("MessagesService") messagesService!: MessagesService;
  /** 施設関係者メッセージサービス */
  @Inject("OtherUserGroupMessagesService") otherUserGroupMessages!: OtherUserGroupMessagesService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  /** メッセージ入力 */
  @Ref() messageFormTab!: SendMessageForm;
  /** 下書き一覧 */
  @Ref() draftMessageListTab!: DraftMessageList;
  /** メッセージ履歴(家族) */
  @Ref() familyMessageHistoriesTab!: SendMessageHistory;
  /** メッセージ履歴(家族) */
  @Ref() otherUserMessageHistoriesTab!: SendMessageOtherUserHistory;
  /** メッセージ送信の使用例モーダル */
  @Ref() sendMessageExampleModal!: SendMessageExampleModal;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** メッセージ送信完了モーダル表示可否 */
  showSendMessageSuccessModal: boolean = false;
  /** メッセージ下書き保存完了モーダル表示可否 */
  showSaveDraftMessageSuccessModal: boolean = false;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** タブインデックス(0始まり) */
  tabIndex: number = 0;
  /** メッセージ詳細タブ */
  tabs: Array<any> = [];
  /** 詳細タブからの戻り先 */
  backTabIndex: number = 0;
  /** 詳細タブ閉じるボタンが押下されたか */
  onCloseButton: boolean = false;

  /** 履歴（家族）の未読が存在するか */
  showSendMessageIncoming: boolean = false;
  /** 履歴（施設関係者）の未読が存在するか */
  showOtherUserGroupSendMessageIncoming: boolean = false;

  /** 現在のアップロード数 */
  currentUploadCount: number = 0;
  /** アップロード数最大値 */
  uploadCount: number = 0;
  /** プログレス付きローディング表示可否 */
  progressLoading: boolean = false;
  /** プログレス付きローディングメッセージ */
  progressMessage: string = "";

  /** 家族メッセージ削除確認モーダル表示可否 */
  showConfirmFamilyMessageDeleteModal = false;
  /** 削除対象の家族メッセージ */
  deleteTargetFamilyMessage: SendMessageHistoryTableItem | null = null;
  /** 施設関係者メッセージ削除確認モーダル表示可否 */
  showConfirmOtherUserMessageDeleteModal = false;
  /** 削除対象の施設関係者メッセージ */
  deleteTargetOtherUserMessage: SendMessageHistoryTableItem | null = null;
  /** メッセージ削除完了モーダル表示可否 */
  showDeleteMessageSuccessModal = false;

  /** ファイルアップロードエラーモーダル表示可否 */
  showUploadErrorModal: boolean = false;

  get _disableUseBasicSetting(): boolean {
    return !userStore.loginUser.permissions.sendMessagesFunction.useBasicSetting;
  }

  get _disableUseTemplate(): boolean {
    return !userStore.loginUser.permissions.sendMessagesFunction.useTemplate;
  }

  get _enableUseSaveDraftMessage(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSaveDraftMessage;
  }

  /**
   * ### vue lifecycle activated
   */
  public async activated(): Promise<void> {
    this.$validator.errors.clear();
    return;
  }

  /**
   * ### vue lifecycle mounted
   *
   * - 表示判断のためにプラン種別を設定する
   * - 「下書き一覧」タブの活性/非活性を設定する
   *   - フリープラン以下なら「下書き一覧」タブは非活性
   * - バッジを更新する
   */
  public async mounted(): Promise<void> {
    this.planType = userStore.facility.planType;

    this.refreshFamilyHistoriesBadge();
    this.refreshOtherUserHistoriesBadge();

    return;
  }

  /**
   * ### バッジを更新する(履歴家族)
   */
  public async refreshFamilyHistoriesBadge(): Promise<void> {
    try {
      const showSendMessageIncoming: SendMessageRepliesUnreadModel = await this.sendMessageRepliesService.getUnreadInFacility(userStore);
      this.showSendMessageIncoming = showSendMessageIncoming.unread;
    } catch (error) {
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### バッジを更新する(履歴施設関係者)
   */
  public async refreshOtherUserHistoriesBadge(): Promise<void> {
    try {
      const showOtherUserGroupSendMessageIncoming: SendMessageRepliesUnreadModel = await this.otherUserGroupSendMessageRepliesService.getUnreadInFacility(userStore);
      this.showOtherUserGroupSendMessageIncoming = showOtherUserGroupSendMessageIncoming.unread;
    } catch (error) {
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### メッセージを送信する
   */
  public async sendMessage(message: {
    sendLineMessage: SendLineMessagesPostModel | SendOtherUserMessagesagesPostModel | undefined;
    sendMailMessage: SendMailMessagesPostModel | SendOtherUserMailMessagesPostModel | undefined;
    sendTarget: "family" | "otherUser";
    files: Array<ExtDraggableFile>;
    draftMessageId: number;
  }): Promise<void> {
    // ファイルが存在すればアップロードする
    let fileUrls: string[] = [];
    let fileNames: string[] = [];

    // ファイルアップロードするタイミングでファイルが削除（移動含む）、リネームされた場合は失敗するのでここでtry-catchする
    // アップロードに失敗した場合は添付されたファイルを全てリセットしてモーダルで再添付を促す
    try {
      if (0 < message.files.length) {
        const targetFiles = [];
        for (const file of message.files) {
          if (file.type == "existing" && !file.fileObject) {
            targetFiles.push(await this.getS3File(file.url as string, file.name));
          } else {
            targetFiles.push(file.fileObject as File);
          }
        }
        const urls: Array<S3LocationResponse> = await this.createUploadUrls(targetFiles, S3LocationType.MESSAGE);

        // プログレス付きモーダルを表示する
        // 進捗はファイルのアプロード状況を反映させるようにする
        this.currentUploadCount = 0;
        this.uploadCount = message.files.length;
        this.progressMessage = "ファイルアップロード中。\n完了するまでそのままお待ちください。\nメッセージ送信中に別画面に遷移しますと処理がキャンセルされます。";
        this.progressLoading = true;
        // アップロード
        for (let i = 0; i < urls.length; i++) {
          this.currentUploadCount = i;
          await this.s3UploadsService.uploadFile(urls[i], targetFiles[i]);

          // DBにはファイルではなく、添付ファイルのS3URLを保持するためURL配列を作成する
          const preUrl: string = urls[i].url.endsWith("/") ? urls[i].url : `${urls[i].url}/`;
          const s3Url: string = `${preUrl}${urls[i].fields["key"]}`;
          fileUrls.push(s3Url);
        }
        // アップロードしたファイルはサムネイル画像が作成されたり、movからmp4への変換が行われる
        // ファイルの存在確認をして変換されたか確認する
        await this.existFile(fileUrls);

        for (const file of message.files) {
          fileNames.push(file.name);
        }

        this.progressLoading = false;
      }
    } catch (error) {
      this.progressLoading = false;

      this.showUploadErrorModal = true;
      this.messageFormTab.resetFiles();

      return;
    }

    // S3のアップロードは時間がかかるので他画面へ遷移されてしまうことがありえる
    // 画面遷移していたら処理は中断する
    if (this.$route.path != PcUrl.SendMessage) {
      return;
    }

    // LINE送信パラメータが存在すればLINEを送信する
    if (message.sendLineMessage != undefined) {
      this.isBusy = true;
      this.loadingMessage = "送信中...";

      message.sendLineMessage.fileUrls = fileUrls;
      message.sendLineMessage.fileNames = fileNames;

      // 種別で呼び出すAPIを切り替える
      if (message.sendTarget == "family") {
        await this.sendLineMessagesService.post(userStore, message.sendLineMessage);
        this.resetScreenInputTemporaryStore();
      } else if (message.sendTarget == "otherUser") {
        await this.sendOtherUserMessagesService.post(userStore, message.sendLineMessage);
        this.resetScreenInputTemporaryStore();
      }

      this.isBusy = false;
    }

    // メール送信パラメータが存在すればメールを送信する
    if (message.sendMailMessage != undefined) {
      this.isBusy = true;
      this.loadingMessage = "送信中...";

      message.sendMailMessage.fileUrls = fileUrls;
      message.sendMailMessage.fileNames = fileNames;

      // 種別で呼び出すAPIを切り替える
      if (message.sendTarget == "family") {
        await this.sendMailMessagesService.post(userStore, message.sendMailMessage);
        this.resetScreenInputTemporaryStore();
      } else if (message.sendTarget == "otherUser") {
        await this.sendOtherUserMailMessagesService.post(userStore, message.sendMailMessage);
        this.resetScreenInputTemporaryStore();
      }

      this.isBusy = false;
    }

    // 下書きIDが渡された場合は下書きを削除する
    if (message.draftMessageId != undefined) {
      this.isBusy = true;
      this.loadingMessage = "下書き削除中...";

      await this.draftMessagesService.delete(userStore, message.draftMessageId);

      // タブのリストから削除する
      this.draftMessageListTab.deleteDraftMessage(message.draftMessageId);

      this.isBusy = false;
    }

    // 画面遷移していたら処理は中断する
    if (this.$route.path != PcUrl.SendMessage) {
      return;
    }

    // メッセージ送信成功ダイアログを表示する
    this.showSendMessageSuccessModal = true;

    return;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  public async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }

  /**
   * ### ファイルアップロード先のURLを発行する
   */
  public async createUploadUrls(files: Array<File>, s3LocationType: S3LocationType): Promise<Array<S3LocationResponse>> {
    let extensions: Array<string> = [];
    for (const file of files) {
      const _file: Array<string> = file.name.split("/");
      const _extensions: Array<string> = _file[_file.length - 1].split(".");
      extensions.push("." + _extensions[_extensions.length - 1]);
    }
    const params: S3LocationMessage = {
      userId: userStore.loginUser.userId
    };
    const requestBody: S3LocationRequest = {
      type: s3LocationType,
      count: files.length,
      extensions: extensions,
      params: params,
      acl: "public-read"
    };
    const url: Array<S3LocationResponse> = await this.s3LocationsService.post(userStore, requestBody);

    return url;
  }

  /**
   * ### ファイルの存在確認を行う
   */
  public async existFile(fileUrls: Array<string>): Promise<void> {
    // ファイルがアップロードされているかをチェックする
    const fileRequestBody: ExistS3FilesPostModel = { urls: fileUrls };
    await this.existS3FilesService.post(userStore, fileRequestBody);

    // サムネイルのファイルが存在しているかをチェックする
    let thumbnailUrls: Array<string> = [];
    for (const url of fileUrls) {
      // サムネイルのファイル名は<元ファイル名>_thumbnailになる
      const splitedUrl: string[] = url.split("/");
      const splitedFileName: string[] = splitedUrl[splitedUrl.length - 1].split(".");

      // mov、mp4以外の場合はサムネイルをメッセージ送信時に作成するのでスキップ
      if (splitedFileName[1] != "mov" && splitedFileName[1] != "mp4") {
        continue;
      }

      const thumbnailFileName: string = splitedFileName[0] + "_thumbnail.jpeg";
      let thunmbnailUrl: string = "";
      for (let i = 0; i < splitedUrl.length - 1; i++) {
        thunmbnailUrl += splitedUrl[i] + "/";
      }
      thunmbnailUrl += thumbnailFileName;
      thumbnailUrls.push(thunmbnailUrl);
    }

    if (0 < thumbnailUrls.length) {
      const thumbnailRequestBody: ExistS3FilesPostModel = { urls: thumbnailUrls };
      await this.existS3FilesService.post(userStore, thumbnailRequestBody);
    }

    return;
  }

  /**
   * ### メッセージ送信完了後に画面を更新する
   */
  public async onMessageClose(): Promise<void> {
    await this.$timerUtil.setTimeout(4000);
    // 新規送信タブの入力内容を初期化する
    this.refreshSendMessageFormByNoLoading();
    // 履歴タブを最新の状態にする(ローディング無し)
    this.refreshFamilyMessageHistoriesByNoLoading();
    this.refreshOtherUserMessageHistories();
    return;
  }

  /**
   * ### メッセージ下書き保存後に画面を更新する
   */
  public async onDraftMessageClose(): Promise<void> {
    await this.$timerUtil.setTimeout(1500);
    // 新規送信タブの入力内容を初期化する
    this.refreshSendMessageFormByNoLoading();
    // 下書きタブを最新の状態にする(ローディング無し)
    this.refreshDraftMessagesByNoLoading();
    return;
  }

  /**
   * ### 下書きメッセージを保存する
   */
  public async saveDraftMessage(draftMessage: {
    draftMessagesModel: DraftMessagesPostModel | DraftMessagesPatchModel;
    files: Array<ExtDraggableFile>;
    draftMessageId: number | null;
  }) {
    try {
      if (0 < draftMessage.files.length) {
        const targetFiles = [];
        for (const file of draftMessage.files) {
          if (file.type == "existing" && !file.fileObject) {
            targetFiles.push(await this.getS3File(file.url as string, file.name));
          } else {
            targetFiles.push(file.fileObject as File);
          }
        }
        const urls: Array<S3LocationResponse> = await this.createUploadUrls(targetFiles, S3LocationType.DRAFT_MESSAGE);

        // プログレス付きモーダルを表示する
        // 進捗はファイルのアプロード状況を反映させるようにする
        this.currentUploadCount = 0;
        this.uploadCount = draftMessage.files.length;
        this.progressMessage = "ファイルアップロード中。\n完了するまでそのままお待ちください。\n下書き保存中に別画面に遷移しますと処理がキャンセルされます。";
        this.progressLoading = true;

        // アップロード
        let files: Array<DraftMessageFile> = [];
        let fileUrls: string[] = [];

        // ファイルアップロードするタイミングでファイルが削除（移動含む）、リネームされた場合は失敗するのでここでtry-catchする
        // アップロードに失敗した場合は添付されたファイルを全てリセットしてモーダルで再添付を促す
        try {
          for (let i = 0; i < urls.length; i++) {
            this.currentUploadCount = i;
            await this.s3UploadsService.uploadFile(urls[i], targetFiles[i]);

            // DBにはファイルではなく、添付ファイルのS3URLを保持するためURL配列を作成する
            const preUrl: string = urls[i].url.endsWith("/") ? urls[i].url : `${urls[i].url}/`;
            const s3Url: string = `${preUrl}${urls[i].fields["key"]}`;
            files.push({
              url: s3Url,
              name: draftMessage.files[i].name
            });
            fileUrls.push(s3Url);
          }
        } catch (error) {
          this.progressLoading = false;

          this.showUploadErrorModal = true;
          this.messageFormTab.resetFiles();

          return;
        }
        // ファイルがアップロードされているかをチェックする
        const fileRequestBody: ExistS3FilesPostModel = { urls: fileUrls };
        await this.existS3FilesService.post(userStore, fileRequestBody);

        draftMessage.draftMessagesModel.files = files;

        this.progressLoading = false;
      }

      // S3のアップロードは時間がかかるので他画面へ遷移されてしまうことがありえる
      // 画面遷移していたら処理は中断する
      if (this.$route.path != PcUrl.SendMessage) {
        return;
      }

      this.isBusy = true;
      this.loadingMessage = "登録中...";

      if (draftMessage.draftMessageId == null) {
        await this.draftMessagesService.post(userStore, draftMessage.draftMessagesModel);
        this.resetScreenInputTemporaryStore();
      } else {
        await this.draftMessagesService.patch(userStore, draftMessage.draftMessageId, draftMessage.draftMessagesModel);
        this.resetScreenInputTemporaryStore();
      }

      this.isBusy = false;

      this.showSaveDraftMessageSuccessModal = true;
    } catch (error) {
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 409) {
        this.messageFormTab.setErrorMessage("他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。");
        await this.draftMessageListTab.refresh();
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    } finally {
      this.progressLoading = false;
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 下書きメッセージを復元して新規送信タブに反映させる
   *
   * - 「新規送信」タブの入力情報を下書きメッセージで復元させる
   * - 「新規送信」タブをアクティブにする
   */
  public async restoreDraftMessage(draftMessage: DraftMessagesGetModel): Promise<void> {
    await this.messageFormTab.restoreDraftMessage(draftMessage);
    this.tabIndex = 0;
    return;
  }

  /**
   * ### メッセージ履歴(家族)の詳細を新規タブで開く
   */
  public openDetailTab(message: SendMessageHistoryTableItem): void {
    // 現在は詳細タブは1つまで表示可能とする
    this.tabs.splice(0, 1);
    this.tabs.push({
      no: 0,
      title: message.functionContents.title,
      message: message,
      type: 0
    });

    switch (this.planType) {
      // フリープラン
      case PlanType.FREE: {
        // フリープランは「下書き一覧(index:1)」が表示されないので「新規送信(index:0)」の次なのでindex:1になる
        this.backTabIndex = 1;
        break;
      }
      // ベーシックプラン、エントリープラン
      case PlanType.LIGHT:
      case PlanType.BASIC:
      case PlanType.ENTRY: {
        // ライトプラン、ベーシックプラン、エントリープランは「下書き一覧(index:1)」が表示されるが、権限で非表示もあるので計算が必要
        // 権限があれば「新規送信(index:0)」「下書き一覧(index:1)」の次なのでindex:2になる
        // 権限がなければ「新規送信(index:0)」の次なのでindex:1になる
        this.backTabIndex = this._enableUseSaveDraftMessage ? 2 : 1;
        break;
      }
      default: {
        break;
      }
    }

    return;
  }

  /**
   * ### 家族メッセージ削除確認モーダルを表示する
   */
  public onFamilyMessageDelete(message: SendMessageHistoryTableItem): void {
    this.showConfirmFamilyMessageDeleteModal = true;
    this.deleteTargetFamilyMessage = message;
    return;
  }

  /**
   * ### 家族メッセージ削除確認モーダルを表示する
   */
  public async deleteFamilyMessage(message: SendMessageHistoryTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";
    this.showConfirmFamilyMessageDeleteModal = false;

    await this.messagesService.delete(userStore, message.datetime);

    // APIに取得リクエストはしないので、削除したレコードを非表示にする
    this.familyMessageHistoriesTab.deleteItem(message);

    this.isBusy = false;
    this.showDeleteMessageSuccessModal = true;
    return;
  }

  /**
   * ### メッセージ履歴(施設関係者)の詳細を新規タブで開く
   */
  public openOtherUserDetailTab(message: MessageModel): void {
    // 現在は詳細タブは1つまで表示可能とする
    this.tabs.splice(0, 1);
    this.tabs.push({
      no: 1,
      title: message.functionContents.title,
      message: message,
      type: 1
    });

    switch (this.planType) {
      // フリープラン、ライトプランは履歴（施設関係者タブ）は表示されないので対象外
      case PlanType.FREE:
      case PlanType.LIGHT: {
        break;
      }
      // ベーシックプラン、エントリープラン
      case PlanType.BASIC:
      case PlanType.ENTRY: {
        // ライトプラン、ベーシックプラン、エントリープランは「下書き一覧(index:1)」が表示されるが、権限で非表示もあるので計算が必要
        // 権限があれば「新規送信(index:0)」「下書き一覧(index:1)」「履歴（家族）(index:2)」の次なのでindex:3になる
        // 権限がなければ「新規送信(index:0)」「履歴（家族）(index:1)」の次なのでindex:2になる
        this.backTabIndex = this._enableUseSaveDraftMessage ? 3 : 2;
        break;
      }
      default: {
        break;
      }
    }

    return;
  }

  /**
   * ### 施設関係者メッセージ削除確認モーダルを表示する
   */
  public onOtherUserMessageDelete(message: SendMessageHistoryTableItem): void {
    this.showConfirmOtherUserMessageDeleteModal = true;
    this.deleteTargetOtherUserMessage = message;
    return;
  }

  /**
   * ### 施設関係者メッセージ削除確認モーダルを表示する
   */
  public async deleteOtherUserMessage(message: SendMessageHistoryTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";
    this.showConfirmOtherUserMessageDeleteModal = false;

    await this.otherUserGroupMessages.delete(userStore, message.datetime);

    // APIに取得リクエストはしないので、削除したレコードを非表示にする
    this.otherUserMessageHistoriesTab.deleteItem(message);

    this.isBusy = false;
    this.showDeleteMessageSuccessModal = true;
    return;
  }

  /**
   * ### タブの追加・削除イベント
   */
  public changedTab(currentTabs: Array<BTab>): void {
    // メッセージ詳細用タブが追加されたらアクティブにする
    switch (this.planType) {
      // フリープラン
      case PlanType.FREE: {
        // タブ数が新規送信、履歴（家族）、詳細の3なので詳細タブにフォーカスする
        if (3 <= currentTabs.length && currentTabs[2]) {
          currentTabs[2].activate();
        }
        // メッセージ詳細用タブが閉じるボタンでクローズされたら戻り先タブをアクティブにする
        else if (this.onCloseButton == true && 2 == currentTabs.length && currentTabs[this.backTabIndex]) {
          currentTabs[this.backTabIndex].activate();
          this.onCloseButton = false;
        }
        break;
      }
      // ライトプラン
      case PlanType.LIGHT: {
        let addTabCount: number = 0;
        // 下書き保存タブは権限によって表示・非表示が切り替わるので権限を見て可算するか判断する
        addTabCount = this._enableUseSaveDraftMessage ? addTabCount + 1 : addTabCount;

        // タブ数が新規送信、履歴（家族）、詳細の3なので詳細タブにフォーカスする
        if (addTabCount + 3 <= currentTabs.length && currentTabs[addTabCount + 2]) {
          currentTabs[addTabCount + 2].activate();
        } else if (this.onCloseButton == true && addTabCount + 2 == currentTabs.length && currentTabs[this.backTabIndex]) {
          currentTabs[this.backTabIndex].activate();
          this.onCloseButton = false;
        }
        break;
      }
      // ベーシックプラン、エントリープラン
      case PlanType.BASIC:
      case PlanType.ENTRY: {
        let addTabCount: number = 0;
        // 下書き保存タブは権限によって表示・非表示が切り替わるので権限を見て可算するか判断する
        addTabCount = this._enableUseSaveDraftMessage ? addTabCount + 1 : addTabCount;

        // タブ数が新規送信、履歴（家族）、履歴（施設関係者）、詳細の4なので詳細タブにフォーカスする
        if (addTabCount + 4 <= currentTabs.length && currentTabs[addTabCount + 3]) {
          currentTabs[addTabCount + 3].activate();
        } else if (this.onCloseButton == true && addTabCount + 3 == currentTabs.length && currentTabs[this.backTabIndex]) {
          currentTabs[this.backTabIndex].activate();
          this.onCloseButton = false;
        }
        break;
      }
      default: {
        break;
      }
    }

    return;
  }

  /**
   * ### タブの切り替えイベント
   *
   * - メッセージ詳細用タブから他のタブへ移動した場合、メッセージ詳細用タブを削除する
   */
  public activateTab(newTabIndex: number, prevTabIndex: number): void {
    switch (this.planType) {
      // フリープラン
      case PlanType.FREE: {
        if (newTabIndex != 2 && prevTabIndex == 2) {
          this.tabs.splice(0, 1);
        }
        break;
      }
      // ライトプラン、ベーシックプラン、エントリープラン
      case PlanType.LIGHT: {
        let addTabCount: number = 0;
        // 下書き保存タブは権限によって表示・非表示が切り替わるので権限を見て可算するか判断する
        addTabCount = this._enableUseSaveDraftMessage ? addTabCount + 1 : addTabCount;

        // タブ位置が詳細以外であれば詳細タブを削除する
        if (newTabIndex != addTabCount + 2 && prevTabIndex == addTabCount + 2) {
          this.tabs.splice(0, 1);
        }
        break;
      }
      case PlanType.BASIC:
      case PlanType.ENTRY: {
        let addTabCount: number = 0;
        // 下書き保存タブは権限によって表示・非表示が切り替わるので権限を見て可算するか判断する
        addTabCount = this._enableUseSaveDraftMessage ? addTabCount + 1 : addTabCount;

        // タブ位置が詳細以外であれば詳細タブを削除する
        if (newTabIndex != addTabCount + 3 && prevTabIndex == addTabCount + 3) {
          this.tabs.splice(0, 1);
        }
        break;
      }
      default: {
        break;
      }
    }

    return;
  }

  /**
   * ### メッセージ詳細表示用タブを消す
   */
  public closeDetailTab(): void {
    this.tabs.splice(0, 1);
    this.onCloseButton = true;

    return;
  }

  /**
   * ### 新規送信タブを最新の状態にする
   */
  public async refreshSendMessageForm(): Promise<void> {
    await this.messageFormTab.refresh();
    return;
  }

  /**
   * ### 新規送信タブを最新の状態にする
   */
  public refreshSendMessageFormByNoLoading(): void {
    // 画面遷移でコンポーネントがなくなっていた場合に実施しないようにする
    if (this.messageFormTab) {
      this.messageFormTab.refreshByNoLoading();
    }
    return;
  }

  /**
   * ### 下書き一覧タブを最新の状態にする
   */
  public async refreshDraftMessages(): Promise<void> {
    await this.draftMessageListTab.refresh();
    return;
  }

  /**
   * ### 下書き一覧タブを最新の状態にする
   */
  public async refreshDraftMessagesByNoLoading(): Promise<void> {
    // 画面遷移でコンポーネントがなくなっていた場合に実施しないようにする
    if (this.draftMessageListTab) {
      await this.draftMessageListTab.refreshByNoLoading();
    }
    return;
  }

  /**
   * ### 履歴(家族)を最新の状態にする
   */
  public async refreshFamilyMessageHistories(): Promise<void> {
    this.$emit("refresh");
    this.refreshFamilyHistoriesBadge();
    await this.familyMessageHistoriesTab.refresh();
    return;
  }

  /**
   * ### 履歴(家族)を最新の状態にする
   */
  public async refreshFamilyMessageHistoriesByNoLoading(): Promise<void> {
    this.$emit("refresh");
    this.refreshFamilyHistoriesBadge();
    // 画面遷移でコンポーネントがなくなっていた場合に実施しないようにする
    if (this.familyMessageHistoriesTab) {
      await this.familyMessageHistoriesTab.refreshByNoLoading();
    }
    return;
  }

  /**
   * ### 履歴(施設関係者)を最新の状態にする
   */
  public async refreshOtherUserMessageHistories(): Promise<void> {
    this.$emit("refresh");
    this.refreshOtherUserHistoriesBadge();
    await this.otherUserMessageHistoriesTab.refresh();
    return;
  }

  /**
   * ### 履歴(家族)を最新の状態にする
   */
  public async refreshOtherUserMessageHistoriesByNoLoading(): Promise<void> {
    this.$emit("refresh");
    this.refreshOtherUserHistoriesBadge();
    // 画面遷移でコンポーネントがなくなっていた場合に実施しないようにする
    if (this.otherUserMessageHistoriesTab) {
      await this.otherUserMessageHistoriesTab.refreshByNoLoading();
    }
    return;
  }

  /**
   * ### 画面入力情報のstoreをリセットする
   */
  public resetScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.initializeScreenInputTemporary();
    return;
  }

  /**
   * ### 宛先グループ一覧画面へ遷移する
   */
  public gotoSendMessageGroupList(): void {
    this.$router.push(PcUrl.SendMessageGroupList);
    return;
  }

  /**
   * ### メッセージ送信基本設定画面へ遷移する
   */
  public gotoSendMessageSettingEdit(): void {
    this.$router.push(PcUrl.SendMessageSettingEdit);
    return;
  }

  /**
   * ### 使用例モーダルを表示する
   */
  public onExampleModal(): void {
    this.sendMessageExampleModal.show();
    return;
  }

  /**
   * ### メッセージ送信テンプレート一覧へ遷移する
   */
  public gotoSendMessageTemplateList(): void {
    this.$router.push(PcUrl.SendMessageTemplateList);
    return;
  }

  /**
   * ### vue lifecycle deactivated
   *
   * - コンポーネントをkeep-aliveでキャッシュしている
   * - validatorインスタンスもキャッシュしてしまっているので、リセットする
   */
  async deactivated() {
    await this.$validator.reset();
    this.$validator.errors.clear();
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#message-register {
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;

  .box {
    .setting-btn {
      margin-left: 12px;
    }
    .template-btn {
      margin-left: 12px;
    }
    .tab {
      margin-top: 24px;
    }
    .tab-name {
      height: 25px;
    }
    .incoming-icon {
      margin-top: -4px;
    }
    .refresh-icon {
      margin-top: -4px;
      @include svg-icon("../../../assets/refresh.svg", $font-base-color, 20px, 20px);
      opacity: 0.5;
      text-shadow: 0 1px 0 #fff;
      cursor: pointer;
    }
    .refresh-icon:hover {
      opacity: 0.75;
    }

    .message-detail-tab-title {
      max-height: 24px;

      .message-detail-tab-title-text {
        max-width: 220px;
        margin-right: 12px;
      }
    }

    .send-message-badge {
      padding: 0px 0 0 0;
      content: url(../../../assets/sidemenu-sendmessage-incoming.png);
    }
  }
}
</style>
